module.exports = __webpack_public_path__ + "assets/img/package-default-work.ae6bd99b.svg";